import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { Button, Image } from "antd";
import "twin.macro";
import MainLayout from "../../components/MainLayout/MainLayout";
import { hideScrollbar, LandingTitle } from "../../lib/styles/styleLibrary";
import profile from "../../assets/svg/profile_white.svg";
import gift from "../../assets/svg/gift.svg";
import Auth from "../../lib/middleware/auth";
import Currency from "../../components/Currency/Currency";
import Gifts from "../Gifts/Gifts";
// import { useMediaQuery } from "react-responsive";
import { Donations, Guests } from "..";
import { useParams } from "react-router-dom";
import { active, inactive, Wrapper } from "./component";
import { ROUTES } from "../../settings/routes";
import { useHistory } from "react-router-dom";
import { ChooseWeddingList, PageTitleNavigation } from "../../components";
import { isEmpty } from "../../lib/helpers/helpers";
import { useCouplesData } from "../../redux/api/WeddingAPI";

const Registry = (props) => {
	// const isMobile = useMediaQuery({ maxWidth: 767 });
	const experience = Auth.getExperience();
	const { data: coupleData } = useCouplesData();
	const history = useHistory();
	const page = useParams();
	const { path } = page;
	const [flow, setFlow] = useState(path || "gift");

	const [showModal, setShowModal] = useState(false);
	const [guestcouple, setGuestCouple] = useState({});
	const [couple, setCouple] = useState({});
	const [weddingId, setweddingID] = useState("");

	useEffect(() => {
		if (experience === "guest" && isEmpty(guestcouple)) {
			setShowModal(true);
			return;
		}
		if (experience === "couple" && isEmpty(coupleData?.data)) {
			return;
		}
		experience === "couple"
			? setCouple(coupleData?.data)
			: setCouple(guestcouple);
	}, [experience, guestcouple, coupleData]);

	useEffect(() => {
		if (isEmpty(couple)) {
			return;
		}
		setweddingID(couple?.id);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [couple]);

	return (
		<MainLayout tw="relative">
			<Wrapper>
				<PageTitleNavigation
					title={"My Registry"}
					showBack
					tw="flex flex-row! items-center justify-between  flex-nowrap">
					{flow === "gift" && <Currency changeUserDefault={true} />}
				</PageTitleNavigation>

				<div
					tw="mt-6 ml-6 flex flex-row flex-nowrap items-center gap-2 overflow-x-scroll"
					css={hideScrollbar}>
					<Button
						onClick={() => {
							setFlow("gift");
							history.push(`${ROUTES.REGISTRY}/gift`);
						}}
						css={flow === "gift" ? active : inactive}
						// tw=""
					>
						<Image
							preview={false}
							src={gift}
							alt=""
							width={15}
							height={16}
						/>
						<span tw="text-sm font-semibold">Gift</span>
					</Button>
					{experience === "couple" && (
						<Button
							onClick={() => {
								setFlow("guests");
								history.push(`${ROUTES.REGISTRY}/guests`);
							}}
							css={flow === "guests" ? active : inactive}>
							<Image
								preview={false}
								src={profile}
								alt=""
								width={15}
								height={16}
							/>
							<span tw="text-sm font-semibold">Guests</span>
						</Button>
					)}
					<Button
						onClick={() => {
							setFlow("donations");
							history.push(`${ROUTES.REGISTRY}/donations`);
						}}
						css={flow === "donations" ? active : inactive}>
						Donations{" "}
					</Button>
				</div>

				<div tw="mt-4 w-full h-full">
					{flow === "gift" && (
						<Gifts weddingId={weddingId} couple={couple} />
					)}
					{flow === "guests" && (
						<Guests weddingId={weddingId} couple={couple} />
					)}
					{flow === "donations" && (
						<Donations weddingId={weddingId} couple={couple} />
					)}
				</div>

				<ChooseWeddingList
					showModal={showModal}
					setShowModal={() => setShowModal()}
					setWeddingDetails={(v) => setGuestCouple(v)}
				/>
			</Wrapper>
		</MainLayout>
	);
};

export default Registry;
